// Module
var code = "<div class=\"form wt-form-sm\"> <div class=\"padded-control\"> <div class=\"checkbox\" ng-repeat=\"step in vm.steps\"> <label> <input type=\"checkbox\" ng-model=\"step.value\"/> {{step.label|translate}} </label> </div> </div> </div>";
// Exports
module.exports = code;